// مثلا في ملف: directives/onlyLang.js

export default {
  mounted(el, binding) {
    const lang = binding.value; // 'en' or 'ar'
    console.log("gal")
    el.addEventListener('input', () => {
      let val = el.value;
      if (lang === 'en') {
        // remove Arabic letters
        val = val.replace(/[\u0600-\u06FF]/g, '');
        
      } else if (lang === 'ar') {
        // remove Latin letters & digits
        val = val.replace(/[A-Za-z0-9]/g, '');
        console.log(val)
      }
      el.value = val;
      el.dispatchEvent(new Event('input')); // to sync with v-model
    });
  }
};
